const backgroundColor = (color) => {
  switch (color) {
    case "none":
      return "";

    case "white":
      return "background-white";

    case "gray":
      return "background-gray";

    default:
      return null;
  }
};

export default backgroundColor;
